import React, { useMemo, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { clearError, throwError } from 'redux/actions/actions';

type Options = { callback: () => void; after?: boolean };

function useError() {
  const dispatch = useDispatch();

  const [options, setOptions] = useState<Options | null>(null);

  const onThrowError = useCallback(
    (error: Error, options?: Options) => {
      dispatch(throwError({ error }));
      if (options) {
        setOptions(options);
        !options.after && options.callback();
      }
    },
    [dispatch],
  );

  const onClearError = useCallback(() => {
    dispatch(clearError());
    if (options) {
      options.after && options.callback();
    }
  }, [dispatch, options]);

  return useMemo(
    () => ({
      onClearError,
      onThrowError,
    }),
    [onClearError, onThrowError],
  );
}

export default useError;
